<div class="accordion panel-group has-padding-top" role="tablist" aria-multiselectable="true">
  <ng-content></ng-content>
</div>
